import { createSelector } from "reselect";
import {
  selectedDeliveryMethodSelector,
  deliveryInfoSelector,
  selfActivationSelector,
  channelSelector,
  deliveryModesSelector,
  personalDetailsSelector,
  rescheduleDeliverySelector,
  manualEkycFormSelector,
  formValuesSelector
} from "ducks/selectors";
import { scheduleDeliveryDetailsSelector } from "./scheduleDeliveryDetails";
import { uploadIdentitySelector } from "./forms/uploadIdentity";
import { currencyFormatSelector } from "./appSettings";
import { localeSelector } from "ducks/selectors";
import get from "lodash/get";
import uniqBy from "lodash/uniqBy";
import map from "lodash/map";
import find from "lodash/find";
import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";
import isArray from "lodash/isArray";
// Commenting for 14557 reversal for state parameter

import {
  constructDeliverySlotDates,
  getDeliverySlots,
  getDeliverySlotsForDate,
  constructFreeDeliverySlots,
  constructSpecialDeliverySlots,
  constructPostOfficeDeliverySlots,
  getSlotsForMax21Or7Days
} from "utils/helpers";
import { SELF_ACT_DEL } from "utils/constants";
import { userDetailsConfirmationSelector } from "./forms/userDetailsConfirmation";
import moment from "moment";
import { uniqWith } from "lodash";

const deliverySlotsDomain = state => {
  let deliveryData = get(state, "api.deliverySlots.data.slots", []);
  deliveryData = getSlotsForMax21Or7Days(deliveryData)
  deliveryData= 
  deliveryData = deliveryData.map(dSlot => ({
    id: get(dSlot, "slotId", "X"),
    date: `${moment(
      get(dSlot, "date", "2000-01-01") +
        " " +
        get(dSlot, "startTime", "00-00-00")
    ).format("YYYY-MM-DDTH:mm:00.000+08:00")}`,
    date_string: `${moment(get(dSlot, "date", "2000-01-01")).format(
      "YYYY-MM-DD"
    )}`,
    name: get(dSlot, "courierSlotName", "XXXX"),
    date_time: `${moment(
      get(dSlot, "date", "2000-01-01") +
        " " +
        get(dSlot, "startTime", "00-00-00")
    ).format("YYYY-MM-DD h:mm A")}`,
    cost: get(dSlot, "price.value", 0),
    currency: get(dSlot, "price.currency", ""),
    special: get(dSlot, "deliveryType", "STANDARD") !== "STANDARD",
    display_time: `${moment(
      get(dSlot, "date", "2000-01-01") +
        " " +
        get(dSlot, "startTime", "00-00-00")
    ).format("h:mm A") +
      " - " +
      moment(
        get(dSlot, "date", "2000-01-01") +
          " " +
          get(dSlot, "endTime", "00-00-00")
      ).format("h:mm A")}`,
    courier_slot_name: get(dSlot, "courierSlotName", "XXXX"),
    display_text: `${moment(get(dSlot, "date", "2000-01-01")).format(
      "dddd, Do MMM"
    )}`,
    formatted_display_text: `${moment(get(dSlot, "date", "2000-01-01")).format(
      "dddd, Do MMM"
    )}`,
    range_end_date: null,
    courier: get(dSlot, "courierSlotName", "XXXX"), // Need to update courier to singpost or other value but not available from BE so using slotcode
    reason: "NO_REASON",
    startTime: get(dSlot, "startTime"),
    endTime: get(dSlot, "endTime")
  }));
  return deliveryData;
};

// Commenting for 14557 reversal for state parameter
const deliveryAddressListDomain = state => get(state, "api.addressList.data");
const storeIdValidationDomain = state =>
  get(state, "api.storeIdValidationInfo.data");

export const deliverySlotsSelector = createSelector(
  deliverySlotsDomain,
  deliverySlots =>
    Array.isArray(deliverySlots) ? deliverySlots : Object.values(deliverySlots)
);

// Commenting for 14557 reversal for state parameter
export const deliveryAddressProvinceSelector = createSelector(
  deliveryAddressListDomain,
  provinceData => get(provinceData, "address")
);

const postOfficeDeliverySlotsDomain = state =>
  get(state, "api.postOfficeDeliverySlots.data");

const deliverySlotDetailsDomain = state => get(state, "api.slotDetails.data");

export const postOfficeDeliverySlotsSelector = createSelector(
  postOfficeDeliverySlotsDomain,
  postOfficeDeliverySlots => postOfficeDeliverySlots
);

export const slotDetailsSelector = createSelector(
  deliverySlotDetailsDomain,
  slotDetails => slotDetails
);

// ***************************************************************
// ***************** delivery slots makeSelect *******************
// ***************************************************************
export const deliveryDatesSelector = createSelector(
  selectedDeliveryMethodSelector,
  deliverySlotsSelector,
  scheduleDeliveryDetailsSelector,
  localeSelector,
  (selectedDeliveryMethod, deliverySlots, scheduleDeliveryDetails, locale) => {
    let availableDeliverySlots = get(scheduleDeliveryDetails, "slots", []);

    if (isEmpty(availableDeliverySlots)) availableDeliverySlots = deliverySlots;

    // availableDeliverySlots = groupBy(availableDeliverySlots, item => {
    //   return item.date_string;
    // });

    availableDeliverySlots = uniqBy(availableDeliverySlots, "date_string");

    const slotConfigs = selectedDeliveryMethod.slot_configs;
    const maxFree = get(slotConfigs, "max_free", 50);
    const maxSpecial = get(slotConfigs, "max_special", 50);

    const freeDeliverySlots = getDeliverySlots(
      availableDeliverySlots,
      maxFree,
      deliverySlot => deliverySlot.cost <= 0
    );

    const specialDeliverySlots = getDeliverySlots(
      availableDeliverySlots,
      maxSpecial,
      deliverySlot => deliverySlot.cost > 0
    );

    const allDeliverySlots = freeDeliverySlots.concat(specialDeliverySlots);

    return constructDeliverySlotDates(allDeliverySlots, locale);
  }
);



export const combinedDeliveryDatesSelector = createSelector(
  selectedDeliveryMethodSelector,
  deliverySlotsSelector,
  scheduleDeliveryDetailsSelector,
  localeSelector,
  currencyFormatSelector,
  (
    selectedDeliveryMethod,
    deliverySlots,
    scheduleDeliveryDetails,
    locale,
    currencyFormat
  ) => {
    let availableDeliverySlots = get(scheduleDeliveryDetails, "slots", []);

    if (isEmpty(availableDeliverySlots)) availableDeliverySlots = deliverySlots;

    availableDeliverySlots = uniqBy(availableDeliverySlots, "date_time");

    const slotConfigs = selectedDeliveryMethod.slot_configs;
    const maxFree = get(slotConfigs, "max_free", 0);
    const maxSpecial = get(slotConfigs, "max_special", 0);

    const freeDeliverySlots = getDeliverySlots(
      availableDeliverySlots,
      maxFree,
      deliverySlot => deliverySlot.cost <= 0
    );

    const specialDeliverySlots = getDeliverySlots(
      availableDeliverySlots,
      maxSpecial,
      deliverySlot => deliverySlot.cost > 0
    );

    const allDeliverySlots = freeDeliverySlots.concat(specialDeliverySlots);

    return constructDeliverySlotDates(allDeliverySlots, locale, currencyFormat);
  }
);

export const cvsDeliveryDatesSelector = createSelector(
  selectedDeliveryMethodSelector,
  deliverySlotsSelector,
  scheduleDeliveryDetailsSelector,
  localeSelector,
  currencyFormatSelector,
  (
    selectedDeliveryMethod,
    deliverySlots,
    scheduleDeliveryDetails,
    locale,
    currencyFormat
  ) => {
    let availableDeliverySlots = get(
      scheduleDeliveryDetails,
      "slots",
      deliverySlots
    );
    availableDeliverySlots = uniqBy(
      filter(availableDeliverySlots, { courier_slot_name: "CVSSTD" }),
      "date_string"
    );

    const slotConfigs = selectedDeliveryMethod.slot_configs;
    const maxFree = get(slotConfigs, "max_free", 0);
    const maxSpecial = get(slotConfigs, "max_special", 0);

    const freeDeliverySlots = getDeliverySlots(
      availableDeliverySlots,
      maxFree,
      deliverySlot => deliverySlot.cost <= 0
    );

    const specialDeliverySlots = getDeliverySlots(
      availableDeliverySlots,
      maxSpecial,
      deliverySlot => deliverySlot.cost > 0
    );

    const allDeliverySlots = freeDeliverySlots.concat(specialDeliverySlots);

    return constructDeliverySlotDates(allDeliverySlots, locale, currencyFormat);
  }
);

export const storeIdInfoSelector = createSelector(
  storeIdValidationDomain,
  storeIdInfo => {
    return storeIdInfo;
  }
);

export const makeSelectDeliveryDates = () => deliveryDatesSelector;
export const makeSelectSlotDetails = () => slotDetailsSelector;
export const makeSelectCombinedDeliveryDates = () =>
  combinedDeliveryDatesSelector;
export const makeSelectCvsDeliveryDates = () => cvsDeliveryDatesSelector;
export const makeSelectStoreIdInfo = () => storeIdInfoSelector;

export const freeDeliverySlotsSelector = createSelector(
  selectedDeliveryMethodSelector,
  deliverySlotsSelector,
  deliveryInfoSelector,
  scheduleDeliveryDetailsSelector,
  uploadIdentitySelector,
  selfActivationSelector,
  userDetailsConfirmationSelector,
  channelSelector,
  personalDetailsSelector,
  rescheduleDeliverySelector,
  manualEkycFormSelector,
  (
    selectedDeliveryMethod,
    deliverySlots,
    deliveryInfoForm,
    scheduleDeliveryDetails,
    uploadIdentity,
    selfActivationForm,
    userDetailsConfirmationForm,
    channel,
    personalDetails,
    rescheduleDeliveryDetails,
    manualKycForm
  ) => {
    const deliveryInfo =
      channel === SELF_ACT_DEL
        ? selfActivationForm
        : !isEmpty(deliveryInfoForm)
        ? deliveryInfoForm
        : !isEmpty(personalDetails)
        ? personalDetails
        : !isEmpty(rescheduleDeliveryDetails)
        ? rescheduleDeliveryDetails
        : manualKycForm;
    let availableDeliverySlots = get(scheduleDeliveryDetails, "slots", []);

    if (isEmpty(availableDeliverySlots)) availableDeliverySlots = deliverySlots;

    availableDeliverySlots = uniqWith(
      availableDeliverySlots,
      (slotA, slotB) =>
        slotA.date_time === slotB.date_time && slotA.courier === slotB.courier
    );
  
    const date = get(
      deliveryInfo,
      "delivery_date",
      get(
        uploadIdentity,
        "delivery_date",
        get(userDetailsConfirmationForm, "delivery_date")
      )
    );
    if (!date) return [];

    const slotConfigs = selectedDeliveryMethod.slot_configs;
    const maxFree = get(slotConfigs, "max_free", 10);
    const freeDeliverySlots = getDeliverySlots(
      getDeliverySlotsForDate(availableDeliverySlots, date),
      maxFree,
      deliverySlot => deliverySlot.cost <= 0
    );

    return constructFreeDeliverySlots(freeDeliverySlots);
  }
);

export const makeSelectFreeDeliverySlots = () => freeDeliverySlotsSelector;

export const deliveryHomeSlotTypeSelector = createSelector(
  deliveryModesSelector,
  deliveryModes => {
    return get(deliveryModes, "home.slot_types", []);
  }
);

export const makeSelectDeliveryHomeSlotTypeSelector = () =>
  deliveryHomeSlotTypeSelector;

export const specialDeliverySlotsSelector = createSelector(
  selectedDeliveryMethodSelector,
  deliverySlotsSelector,
  deliveryInfoSelector,
  scheduleDeliveryDetailsSelector,
  uploadIdentitySelector,
  currencyFormatSelector,
  selfActivationSelector,
  userDetailsConfirmationSelector,
  channelSelector,
  personalDetailsSelector,
  rescheduleDeliverySelector,
  manualEkycFormSelector,
  (
    selectedDeliveryMethod,
    deliverySlots,
    deliveryInfoForm,
    scheduleDeliveryDetails,
    uploadIdentity,
    currencyFormat,
    selfActivationForm,
    userDetailsConfirmationForm,
    channel,
    personalDetails,
    rescheduleDeliveryDetails,
    manualKycForm
  ) => {
    const deliveryInfo =
      channel === SELF_ACT_DEL
        ? selfActivationForm
        : !isEmpty(deliveryInfoForm)
        ? deliveryInfoForm
        : !isEmpty(personalDetails)
        ? personalDetails
        : !isEmpty(rescheduleDeliveryDetails)
        ? rescheduleDeliveryDetails
        : manualKycForm;
    let availableDeliverySlots = get(
      scheduleDeliveryDetails,
      "slots",
      deliverySlots
    );

    availableDeliverySlots = uniqWith(
      availableDeliverySlots,
      (slotA, slotB) =>
        slotA.date_time === slotB.date_time && slotA.courier === slotB.courier
    );

    const date = get(
      deliveryInfo,
      "delivery_date",
      get(
        uploadIdentity,
        "delivery_date",
        get(userDetailsConfirmationForm, "delivery_date")
      )
    );
    if (!date) return [];

    const slotConfigs = selectedDeliveryMethod.slot_configs;
    const maxSpecial = get(slotConfigs, "max_special", 10);
    const specialDeliverySlots = getDeliverySlots(
      getDeliverySlotsForDate(availableDeliverySlots, date),
      maxSpecial,
      deliverySlot => deliverySlot.cost > 0
    );
    return constructSpecialDeliverySlots(specialDeliverySlots, currencyFormat);
  }
);

export const makeSelectSpecialDeliverySlots = () =>
  specialDeliverySlotsSelector;

export const makeSelectPostOfficeRegions = () =>
  createSelector(postOfficeDeliverySlotsSelector, postOfficeDeliverySlots => {
    return map(get(postOfficeDeliverySlots, "regions", []), region => {
      return { label: region.name, value: region.id };
    });
  });

export const makeSelectPostOfficeDeliverySlots = () =>
  createSelector(
    postOfficeDeliverySlotsSelector,
    localeSelector,
    (postOfficeDeliverySlots, locale) => {
      const { delivery_info_working_hours } = locale;
      const slots = get(
        postOfficeDeliverySlots,
        "post_office_delivery_slots",
        []
      );

      return constructPostOfficeDeliverySlots(
        slots,
        delivery_info_working_hours
      );
    }
  );

export const makeSelectSelectedPostOffice = () =>
  createSelector(
    postOfficeDeliverySlotsDomain,
    deliveryInfoSelector,
    uploadIdentitySelector,
    (postOfficeDeliverySlots, deliveryInfo, uploadIdentity) => {
      const post_office_id = get(
        deliveryInfo,
        "post_office_id",
        get(uploadIdentity, "post_office_id")
      );
      return find(
        get(postOfficeDeliverySlots, "post_office_delivery_slots", []),
        slot => slot.id === parseInt(post_office_id)
      );
    }
  );

/* Commenting for 14557 reversal for state parameter*/
export const makeSelectProvinceList = form =>
  createSelector(deliveryAddressProvinceSelector, province => {
    const provinceList = isArray(province)
      ? [...new Set(province.map(address => get(address, "province")))]
      : [];
    return !isEmpty(provinceList)
      ? provinceList.map(province => {
          return { label: province, value: province };
        })
      : [];
  });

export const makeSelectProvinceCityList = (form, prefix) =>
  createSelector(
    formValuesSelector(form),
    deliveryAddressProvinceSelector,
    (formValues, province) => {
      const provinceData = get(formValues, `${prefix}_province.value`);
      const cityList = filter(
        province,
        item => get(item, "province") === provinceData
      );

      const uniqCityList = isArray(cityList)
        ? [
            ...new Set(
              cityList.map(address => {
                return JSON.stringify({
                  city: get(address, "city"),
                  postalCode: get(address, "postalCode")
                });
              })
            )
          ].map(item => JSON.parse(item))
        : [];
      return !isEmpty(uniqCityList)
        ? uniqCityList.map(address => {
            return {
              label: get(address, "city"),
              postalCode: get(address, "postalCode"),
              value: get(address, "city")
            };
          })
        : [];
    }
  );

export const makeSelectProvinceAreaList = (form, prefix) =>
  createSelector(
    formValuesSelector(form),
    deliveryAddressProvinceSelector,
    (formValues, province) => {
      const city = get(formValues, `${prefix}_city.value`);
      const areaList = filter(province, item => get(item, "city") === city);
      const uniqAreaList = isArray(areaList)
        ? [
            ...new Set(
              areaList.map(address => {
                return {
                  area: get(address, "area"),
                  postalCode: get(address, "postalCode")
                };
              })
            )
          ]
        : [];
      return !isEmpty(uniqAreaList)
        ? uniqAreaList.map(address => {
            return {
              label: get(address, "area"),
              postalCode: get(address, "postalCode"),
              value: get(address, "area")
            };
          })
        : [];
    }
  );
